<div
  class="chip"
  [ngClass]="{ wolt: integration === 'wolt', jet: integration === 'jet', uber: integration === 'uber' }"
>
  <span>{{ integration | uppercase }}</span>
</div>
